import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Form,
  Alert,
  Button,
  Input,
  FormFeedback,
  InputGroup,
  CardFooter,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";

import Spinners from "components/Common/Spinner";
import { Value } from "sass";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { string } from "prop-types";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const RequestList = (props) => {
  document.title = "Request List - VUF";
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "RequestList", link: "#" },
  ];
  const [userdataList, setuserdataList] = useState([]);
  const [DateRange, setDateRange] = useState({});
  const [SelectUser, setSelectUser] = useState({});
  const [selectionRange, setselectionRange] = useState({});

  const [countries, setcountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);
  const [cityList, setcityList] = useState([]);

  const [selectedCity, setselectedCity] = useState({});
  const [selectedCountry, setselectedCountry] = useState({});
  const [selectedDistrict, setselectedDistrict] = useState({});
  const [selectedState, setselectedState] = useState({});

  const [cityCode, setcityCode] = useState({});
  const [districtCode, setdistrictCode] = useState({});
  const [stateCode, setStateCode] = useState({});
  const [countryDataCode, setcountryDataCode] = useState({});

  const Values = {
    copy: [],
  };

  const UserType = [
    {
      options: [
        { label: "All", value: "" },
        { label: "Accepted", value: "Accept" },
        { label: "Rejected", value: "Rejected" },
        { label: "Complete", value: "Complete" },
      ],
    },
  ];
  const [isLoading, setLoading] = useState(false);
  const [form, setValues] = useState(Values);
  const [copy, setcopy] = useState([]);

  const hasActiveValue = (value) => {
    if (value === undefined || value === null) return false;
    if (typeof value === "string") return value.trim() !== "";
    if (typeof value === "object") {
      if ("value" in value) {
        return value.value !== "" && value.value !== undefined && value.value !== null;
      }
      if ("label" in value) {
        return value.label !== "" && value.label !== "--Select--";
      }
      return Object.keys(value).length > 0;
    }
    return Boolean(value);
  };

  useEffect(() => {
    props.setBreadcrumbItems("List", breadcrumbItems);
  });

  useEffect(() => {
    setSelectUser({ label: "All", value: "" });
    getusers(
      true,
      "",
      selectionRange.startDate,
      selectionRange.endDate,
      "",
      "",
      "",
      "",
    );

    // Perform your componentDidMount logic here
  }, []);

  function getusers(
    loading,
    UserType,
    startDate,
    endDate,
    Country,
    state,
    district,
    city,
  ) {
    // getReportDashboard
    setLoading(true);
    console.log(UserType);
    let urlPath = "benefitRequest/report/";
    const isFilterApplied =
      hasActiveValue(UserType) ||
      Boolean(startDate && endDate) ||
      hasActiveValue(Country) ||
      hasActiveValue(state) ||
      hasActiveValue(district) ||
      hasActiveValue(city);

    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        filter: isFilterApplied,
        UserType: UserType,
        country:
          Country?.label == "" || Country?.label == "--Select--"
            ? ""
            : Country?.label || "",
        city:
          city?.label == "" || city?.label == "--Select--"
            ? ""
            : city?.label || "",
        state:
          state?.label == "" || state?.label == "--Select--"
            ? ""
            : state?.label || "",
        distict:
          district?.label == "" || district?.label == "--Select--"
            ? ""
            : district?.label || "",
        startDate: startDate || "",
        endDate: endDate || "",
        village: "",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status && responseData.data != undefined) {
          var userList = responseData.data;
          setuserdataList(responseData.data);
          let datacopy = [];
          //userList.forEach(d => datacopy.push({ 'Sr.no.': userList.indexOf(d) + 1, FirstName: d.firstName, LastName: d.lastName, nickname: d.nickname, MobileNo: d.countryCode + d.mobileNo, profession: d.profession, otherProfession: d.otherProfession, Address: d.street_address, country: d.country, state: d.state, district: d.district, city: d.city, village: d.village, area: d.area, dob: d.dob, age: d.age, remarks: d.remarks }))
          userList.forEach((user) =>
            datacopy.push({
              "Sr.no.": userList.indexOf(user) + 1,
              Organization: user.OrganizationId.firstName,
              Category: user.CategoryId.name,
              RequestedBy: user.userId.firstName + " " + user.userId.lastName,
              requestStatus: user.requestStatus,
              Location:
                user.userId.city != null &&
                user.userId.district != undefined &&
                user.userId.district != ""
                  ? user.userId.district +
                    ", " +
                    user.userId.state +
                    ", " +
                    user.userId.country
                  : "",
              Address: user.OrganizationId.street_address,
            }),
          );

          setcopy(datacopy);
          if (Country == "" && city == "" && state == "" && district == "") {
            onGetCountryList();
          }
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {});
  }

  function onGetCountryList() {
    let urlPath = "auth/CountryList";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;

          let countries = [];
          countries.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            countries.push({ label: c.country_name, value: c.id });
          });
          console.log(countries);
          if (userdataList.length > 0) {
            var countr = userdataList
              .map(function (a) {
                return a.country;
              })
              .filter((item, i, arr) => arr.findIndex((t) => t === item) === i);
            console.log(countr);

            countries = countries.filter(
              (s) =>
                countr.filter((a) => a != undefined && a == s.label).length > 0,
            );
            console.log(countries);
          }
          console.log(UserType);
          const cot = [{ options: countries }];
          console.log(cot);

          setcountries(cot);

          setselectedCity("");
          setselectedDistrict("");
          setselectedState("");
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetStateList(data) {
    setcountryDataCode(data);
    if (data != null && data != undefined && data != "") {
      let urlPath = "auth/StatesList/" + data;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: Body,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          // // // console.log("RES ",responseData)
          if (responseData.status) {
            var data = responseData.response;

            let stateList = [];
            stateList.push({ label: "--Select--", value: "" });
            data.map((c, i) => {
              stateList.push({ label: c.state_title, value: c.state_id });
            });
            console.log(stateList);
            if (selectedState == "" || selectedState == null) {
              var seledlis = userdataList
                .map(function (a) {
                  return a.state;
                })
                .filter(
                  (item, i, arr) => arr.findIndex((t) => t === item) === i,
                );
              console.log(seledlis);

              stateList = stateList.filter(
                (s) =>
                  seledlis.filter((a) => a != undefined && a == s.label)
                    .length > 0,
              );
              console.log(stateList);
            }
            const cot = [{ options: stateList }];
            setStateList(cot);

            setselectedDistrict("");
            setselectedCity("");
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => {});
    }
  }
  function onGetDistrictList(data) {
    setStateCode(data);

    let urlPath = "auth/DistrictsList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;
          let districtList = [];
          districtList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            districtList.push({ label: c.district_title, value: c.districtid });
          });
          if (selectedDistrict == "" || selectedDistrict == null) {
            var seledlis = userdataList
              .map(function (a) {
                return a.district;
              })
              .filter((item, i, arr) => arr.findIndex((t) => t === item) === i);
            console.log(seledlis);

            districtList = districtList.filter(
              (s) =>
                seledlis.filter((a) => a != undefined && a == s.label).length >
                0,
            );
            console.log(districtList);
          }
          const cot = [{ options: districtList }];
          setdistrictList(cot);
          selectedCity("");
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetCitiesList(data) {
    setdistrictCode(data);
    let urlPath = "auth/CitiesList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        // // // console.log("RES ",responseData)
        if (responseData.status) {
          var data = responseData.response;
          let cityList = [];
          cityList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            cityList.push({ label: c.name, value: c.id });
          });
          if (selectedCity == "" || selectedCity == null) {
            var seledlis = userdataList
              .map(function (a) {
                return a.city;
              })
              .filter((item, i, arr) => arr.findIndex((t) => t === item) === i);
            console.log(seledlis);

            cityList = cityList.filter(
              (s) =>
                seledlis.filter((a) => a != undefined && a == s.label).length >
                0,
            );
            console.log(cityList);
          }
          const cot = [{ options: cityList }];
          setcityList(cot);
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }

  function exportToExcel(data) {
    var fileName = "BenefitRequestList";
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }

  function dateval(val) {
    console.log(val);
    setDateRange(val);
    if (val.length == 2) {
      setselectionRange({ startDate: val[0], endDate: val[1] });
      getusers(
        true,
        SelectUser.value,
        val[0],
        val[1],
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity,
      );
    } else if (val.length == 0) {
      getusers(
        false,
        SelectUser.value,
        selectionRange.startDate,
        selectionRange.endDate,
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity,
      );
    }
  }

  const formattedEventList = userdataList.map((user) => ({
    ...user,
    Organization: user.OrganizationId.firstName,
    Category: user.CategoryId.name,
    RequestedBy: user.userId.firstName + " " + user.userId.lastName,
    requestStatus: user.requestStatus,
    Location:
      user.userId.district != null &&
      user.userId.district != undefined &&
      user.userId.district != ""
        ? user.userId.district +
          ", " +
          user.userId.state +
          ", " +
          user.userId.country
        : "",
    Address: user.OrganizationId.street_address,
  }));

  const tableData = {
    columns: [
      {
        label: "Organization",
        field: "Organization",
        sort: "asc",
        width: 10,
      },
      {
        label: "Category",
        field: "Category",
        sort: "asc",
        width: 10,
      },
      {
        label: "RequestedBy",
        field: "RequestedBy",
        sort: "asc",
        width: 10,
      },
      {
        label: "Status",
        field: "requestStatus",
        sort: "asc",
        width: 10,
      },
      {
        label: "User Location",
        field: "Location",
        sort: "asc",
        width: 5,
      },
      {
        label: "Org. Address",
        field: "Address",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedEventList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row className="align-items-center">
                  <Col md="6">
                    <CardTitle className="h4 mb-0">Request List</CardTitle>
                  </Col>
                  <Col md="6" className="text-end">
                    <div className="d-flex justify-content-end">
                      {userdataList.length > 0 ? (
                        <button
                          className=" btn btn-outline-success float-right "
                          onClick={(event) => exportToExcel(copy)}
                        >
                          Export to Excel
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div class="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Request Status:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={SelectUser}
                        onChange={(e) => {
                          setSelectUser(e);
                          getusers(
                            false,
                            e.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            "",
                            "",
                            "",
                            "",
                          );
                        }}
                        options={UserType}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Country / દેશ:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedCountry}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            boxShadow: "none",
                            borderColor: state.isFocused
                              ? "#ccc"
                              : baseStyles.borderColor,
                            "&:hover": {
                              borderColor: "#ccc",
                            },
                          }),
                          input: (baseStyles) => ({
                            ...baseStyles,
                            "& input": {
                              outline: "none !important", // Forces the browser outline away
                              boxShadow: "none !important",
                            },
                          }),

                          container: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                          }),
                        }}
                        onChange={(e) => {
                          setselectedCountry(e);
                          setselectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setselectedCity({ label: "--Select--", value: "" });
                          setselectedState({ label: "--Select--", value: "" });
                          getusers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            e,
                            "",
                            "",
                            "",
                          );
                          onGetStateList(e.value);
                        }}
                        options={countries}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>State / રાજ્ય:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedState}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            boxShadow: "none",
                            borderColor: state.isFocused
                              ? "#ccc"
                              : baseStyles.borderColor,
                            "&:hover": {
                              borderColor: "#ccc",
                            },
                          }),
                          input: (baseStyles) => ({
                            ...baseStyles,
                            "& input": {
                              outline: "none !important", // Forces the browser outline away
                              boxShadow: "none !important",
                            },
                          }),

                          container: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                          }),
                        }}
                        onChange={(e) => {
                          setselectedState(e);
                          setselectedDistrict({
                            label: "--Select--",
                            value: "",
                          });
                          setselectedCity({ label: "--Select--", value: "" });
                          getusers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            e,
                            "",
                            "",
                          );
                          onGetDistrictList(e.value);
                        }}
                        options={stateList}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>District / જિલ્લો:</label>
                      <Select
                        classNamePrefix="select2-selection"
                        value={selectedDistrict}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            boxShadow: "none",
                            borderColor: state.isFocused
                              ? "#ccc"
                              : baseStyles.borderColor,
                            "&:hover": {
                              borderColor: "#ccc",
                            },
                          }),
                          input: (baseStyles) => ({
                            ...baseStyles,
                            "& input": {
                              outline: "none !important", // Forces the browser outline away
                              boxShadow: "none !important",
                            },
                          }),

                          container: (baseStyles) => ({
                            ...baseStyles,
                            outline: "none",
                          }),
                        }}
                        onChange={(e) => {
                          setselectedDistrict(e);
                          setselectedCity({ label: "--Select--", value: "" });
                          getusers(
                            false,
                            SelectUser.value,
                            selectionRange.startDate,
                            selectionRange.endDate,
                            selectedCountry,
                            selectedState,
                            e,
                            "",
                          );
                          onGetCitiesList(e.value);
                        }}
                        options={districtList}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className='col-md-4'>
                                        <div className="form-group" >
                                            <label>City / શહેર:</label>
                                            <Select classNamePrefix="select2-selection"
                                                value={selectedCity}
                                                onChange={(e) => { setselectedCity(e); getusers(false, SelectUser.value, selectionRange.startDate, selectionRange.endDate, selectedCountry, selectedState, selectedDistrict, e) }}
                                                options={cityList}
                                            />
                                        </div>
                                    </div> */}
                <MDBDataTable responsive striped bordered data={tableData} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};
export default connect(null, { setBreadcrumbItems })(RequestList);
